import UIkit from 'packs/uikit.min';
$(document).on('turbolinks:load', function() {
    $(".sidenav-link").on('click', function(event) {
        UIkit.offcanvas("#sidenav").hide();
    });
});